
import { AjaxGet, AjaxPost, MonthStringFromTimestamp } from "@/App.vue";
import Note from "../../../shared/Note";
import Vue from "vue";

class NoteData {
    public NoteText = "";
    public Notes: { [key: string]: Note } = {};
}

export default Vue.extend({
    name: "notes",

    data() {
        return new NoteData();
    },

    created() {
        this.refresh();
    },

    methods: {

        refresh() {

            AjaxGet<{ [id: string]: Note }>(this.url, true).then((data) => {
                this.NoteText = "";
                this.Notes = data;
            });

        },

        noteString(note: Note): string {
            return "Posted by "
                + note.createdBy
                + " on " + MonthStringFromTimestamp(note.timestamp)
                + ": " + note.text;
        },

        submitNote() {
            const note: Note = {
                text: this.NoteText,
                timestamp: new Date().getTime(),
                createdBy: "", // This is set by the server
            };

            AjaxPost(this.url, note, true).then(() => {
                this.refresh();
            });

        },

    },
    props: {
        url: String,
    },
});
